$(document).ready(function () {

  if (typeof meta !== "undefined" && typeof meta.page !== "undefined" && meta.page.pageType == "cart") {

    var app_url = "https://phpstack-1326704-4853270.cloudwaysapps.com";

    $.ajax({
      type: "GET",
      url: "/cart.json",
      success: function (cart_data) {

        $.ajax({
          url: `${app_url}/localized-checkout`,
          type: "GET",
          data: {
            cart_data: cart_data
          },
          success: function (response) {
            if (response.status == "success") {
              var variants = response.data;
              var checkoutUrl = 'https://dus.colognewatch.de/pages/loading-page';

              $.each(variants, function(index, item) {
                  if (index === 0) {
                      checkoutUrl += `?v_id=${item.shopify_id}&q=${item.quantity}`;
                  } else {
                      checkoutUrl += `&v_id=${item.shopify_id}&q=${item.quantity}`;
                  }
              });

              // ===== Tracking-Parameter für Cross-Domain Tracking =====
              var currentParams = new URLSearchParams(window.location.search);
              var trackingParams = [
                'fbclid',
                'gclid',
                'utm_source',
                'utm_medium',
                'utm_campaign',
                'utm_content',
                'utm_term',
                '_ga',
                '_gl'
              ];

              trackingParams.forEach(function(param) {
                var value = currentParams.get(param);
                if (value) {
                  var separator = checkoutUrl.includes('?') ? '&' : '?';
                  checkoutUrl += separator + param + '=' + encodeURIComponent(value);
                }
              });

              // ===== Meta _fbc Cookie auslesen (falls fbclid nicht in URL) =====
              if (!currentParams.get('fbclid')) {
                var fbcCookie = document.cookie.split('; ').find(function(row) { return row.startsWith('_fbc='); });
                if (fbcCookie) {
                  var fbcValue = fbcCookie.substring(5);
                  var separator = checkoutUrl.includes('?') ? '&' : '?';
                  checkoutUrl += separator + '_fbc=' + encodeURIComponent(fbcValue);
                }
              }

              // ===== Meta _fbp Cookie weitergeben (Browser ID) =====
              var fbpCookie = document.cookie.split('; ').find(function(row) { return row.startsWith('_fbp='); });
              if (fbpCookie) {
                var fbpValue = fbpCookie.substring(5);
                var separator = checkoutUrl.includes('?') ? '&' : '?';
                checkoutUrl += separator + '_fbp=' + encodeURIComponent(fbpValue);
              }
              // ===== Ende Tracking-Parameter =====

              if (checkoutUrl !== null) {

                  $('.cart__checkout-button').click(function(event) {
                      event.preventDefault();

                      fetch('/cart/clear.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Requested-With': 'XMLHttpRequest'
                        }
                      })
                      .then(response => {
                        if (response.ok) {
                          window.location.href = checkoutUrl;
                        } else {
                          console.error('Failed to clear the cart.');
                        }
                      })
                      .catch(error => {
                        console.error('Error:', error);
                      });

                  });

              }

            }
          },
        });

      }
    });

  }

});